/**
 * @generated SignedSource<<f7eabee968bf0eeef4805f967c38f9d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageDateEditTabs_packageDate$data = {
  readonly flight: {
    readonly id: string;
  } | null;
  readonly id: string;
  readonly package: {
    readonly " $fragmentSpreads": FragmentRefs<"PackageDateEditFlight_package">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateEditFlight_packageDate" | "PackageDateEditMain_packageDate">;
  readonly " $fragmentType": "PackageDateEditTabs_packageDate";
};
export type PackageDateEditTabs_packageDate$key = {
  readonly " $data"?: PackageDateEditTabs_packageDate$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateEditTabs_packageDate">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageDateEditTabs_packageDate",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Package",
      "kind": "LinkedField",
      "name": "package",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PackageDateEditFlight_package"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Flight",
      "kind": "LinkedField",
      "name": "flight",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageDateEditMain_packageDate"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageDateEditFlight_packageDate"
    }
  ],
  "type": "PackageDate",
  "abstractKey": null
};
})();

(node as any).hash = "2abec41c5a895b9008756d96710fc763";

export default node;
